export default __webpack_public_path__ + "css/order-edit-page.css";